module.exports = __webpack_public_path__ + "static/media/-ve4.5eaaa2bd.png";